import styles from "../../../../../assets/scss/common/modal/loginModal.module.scss";
import React, {useEffect, useState} from "react";
import {SignupBirthdayField} from "./component/SignupBirthdayField";
import {SignupGenderField} from "./component/SignupGenderField";
import {SignupAddressField} from "./component/SignupAddressField";
import {Address, Gender} from "../../../../../types/user";
import {SignupStatus} from "../../SignupModal";
import {useSignupValidator} from "./hooks/useSignupValidator";
import {useUserAgent} from "../../../../../hooks/hooks";
import {StyleRequestType} from "../../../../../types/common";
import {Trans, useTranslation} from "react-i18next";
import {useSignupVerifyActions} from "./hooks/useSignupVerifyActions";
import {SignupSteps, ValidateSignupRequestDTO} from "../../../../../types/signup";

interface Props {
    loginStep: SignupStatus;
    email: string;
    changeSignupStep: (_: SignupStatus) => void;
    birthday: string;
    setBirthday: (_: string) => void;
    gender: Gender;
    setGender: (_: Gender) => void;
    address: Address;
    setAddress: (_: Address) => void;
}

export function SignupInfoStep2({
    loginStep,
    email,
    changeSignupStep,
    birthday,
    setBirthday,
    gender,
    setGender,
    address,
    setAddress,
}: Props){
    const { t } = useTranslation("signupModal");

    const [isHovered, setIsHovered] = useState(false);
    const [showNation, setShowNation] = useState(false);
    const {isDesktop} = useUserAgent();
    const styleRequestType = StyleRequestType.SIGN_UP
    const {verifyLogs} = useSignupVerifyActions();
    const [isValidate, setIsValidate] = useState(false)

    const {
        validate, birthdayValidate, setBirthdayValidate,
        genderValidate, setGenderValidate,
    } = useSignupValidator({
        loginStep, birthday:birthday, gender: gender, address: address
    })
    const onClickNextStep = () =>{
        const result = validate();
        if (result) {
            changeSignupStep(SignupStatus.Sign_UP_INFO_03);
        } else {
            if(isValidate) return;

            setIsValidate(true)
            const dto: ValidateSignupRequestDTO = {
                signupSteps: SignupSteps.STEP2,
                email: email,
                birthday: birthday,
                gender: gender.toString(),
                address: address,
            }
            verifyLogs(dto).then();
        }
    }

    const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const nationField = document.getElementById('nationField');

        if (showNation && nationField && !nationField.contains(target)) {
            setShowNation(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line
    }, [showNation]);

    return (
        <>
            <div className={styles.inputArea}>

                <div className={styles.desc}>
                    <Trans t={t} i18nKey={"signup.step2.title"}
                           components={{accent: <span className={styles.accent} />,br : <br />}}
                    />
                </div>


                {/* 생년월일 */}
                <SignupBirthdayField birthday={birthday} setBirthday={setBirthday}
                                     birthdayValidate={birthdayValidate} setBirthdayValidate={setBirthdayValidate}
                                     styleRequestType={styleRequestType}
                />

                {/* 성별 */}
                <SignupGenderField gender={gender} setGender={setGender}
                                   genderValidate={genderValidate} setGenderValidate={setGenderValidate}
                                   styleRequestType={styleRequestType}
                />

                {/* 주소 */}
                <div id={"nationField"}>
                    <SignupAddressField address={address} setAddress={setAddress}
                                        showNation={showNation} setShowNation={setShowNation}
                                        styleRequestType={styleRequestType}
                    />
                </div>


                <div className={`${styles.buttonsWrapper} ${isDesktop ? styles.withMarginTop : ''}`}>
                    <button type="button"
                            className={`${styles.signUpNextButton} ${isHovered ? styles.signUpNextHoverButton : ''}`}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={onClickNextStep}
                    >
                        {t("btn.next")}
                    </button>
                </div>
            </div>
        </>
    )
}